// extracted by mini-css-extract-plugin
export default {"outliner__empty":"lsf-outliner__empty","waiting":"lsf-waiting"};
    if(module.hot) {
      // 1653630374662
      var cssReload = require("/home/runner/work/label-studio-frontend/label-studio-frontend/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  